<div class="flex flex-col w-full">
  <div class="flex flex-row justify-between items-center">
    @if (!field?.props?.departureQuestions) {
      @if (field?.props?.label && !field.props.descriptionSlug) {
        <div class="mb-1">
          <span class="font-medium">{{field?.props?.label}}</span>
        </div>
      }
      @if (description) {
        <div class="mb-1 ql-snow">
          <div class="ql-editor p-0" [innerHTML]="description | safe: 'html'"></div>
        </div>
      }
    }
    @if (isCustomerRole && !field.model?.onlyDrawSignature) {
      <mat-slide-toggle [formControl]="drawSignatureControl">Draw Signature</mat-slide-toggle>
    }
  </div>
  <div class="relative">
    <button class="absolute top-2 right-1.5 z-10" mat-icon-button aria-label="Clear Signature" type="button"
      (click)="resetImage()" [ngClass]="{'hidden': !drawSignatureControl.value}">
      <mat-icon [svgIcon]="'heroicons_solid:trash'"></mat-icon>
    </button>
    <mat-form-field class="w-full signature mt-1" appearance="outline">
      <input matInput type="text" [formControl]="formControl" class="hidden" />
      <div #sigContainer>
        <signature-pad #signature [options]="signaturePadOptions"
        class="bg-white w-full" (drawEnd)="drawComplete()"></signature-pad>
      </div>
      <div #detailsContainer class="relative w-100 h-50 hidden">
        <canvas #detailsPad id="details-pad" class="w-100 h-50" width=400 height=200></canvas>
      </div>
    </mat-form-field>
  </div>
  <div class="flex flex-col sm:flex-row sm:space-x-4">
    <mat-form-field class="fuse-mat-dense w-full signature-info-field" appearance="outline">
      <mat-label>Signed By</mat-label>
      <input [formControl]="userNameFormControl" matInput type="text" placeholder="Signed by" class="signature-info-input"/>
    </mat-form-field>
    <mat-form-field class="fuse-mat-dense w-full signature-info-field" appearance="outline">
      <mat-label>Signed on</mat-label>
      <input [formControl]="dateFormControl" matInput type="text" class="signature-info-input"/>
    </mat-form-field>
  </div>
</div>